import { useState, useCallback } from 'react'

// Panier de commande Tournee/Paniers — memorise en localStorage (§5 quater :
// le panier survit a la visite, sans compte requis). Structure : { [tourId]: { [tourOfferId]: qty } }.
const KEY = 'lyannaj_tournee_cart'
const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || {} } catch { return {} } }
const write = (v) => { try { localStorage.setItem(KEY, JSON.stringify(v)) } catch { /* quota / mode prive */ } }

export default function useTourneeCart() {
  const [carts, setCarts] = useState(read)

  const add = useCallback((tourId, offerId, delta = 1) => {
    setCarts((prev) => {
      const tour = { ...(prev[tourId] || {}) }
      const q = (tour[offerId] || 0) + delta
      if (q <= 0) delete tour[offerId]
      else tour[offerId] = q
      const next = { ...prev, [tourId]: tour }
      write(next)
      return next
    })
  }, [])

  const clear = useCallback((tourId) => {
    setCarts((prev) => {
      const next = { ...prev }
      delete next[tourId]
      write(next)
      return next
    })
  }, [])

  const cartFor = (tourId) => carts[tourId] || {}
  const countFor = (tourId) => Object.values(carts[tourId] || {}).reduce((s, q) => s + q, 0)

  return { cartFor, countFor, add, clear }
}
